// Imports
import React from "react"
import { calc } from "@vanilla-extract/css-utils"
import { Tag } from "@molecules"
import { ScrollContainer } from "react-indiana-drag-scroll"
import {
  heroContainerMediaQueries,
  useWindowWidth,
  generateString,
} from "@utils"

export const ServicesFilter = ({ filters, active, handleCategoryClick }) => {
  const windowWidth = useWindowWidth()

  return (
    <ScrollContainer>
      <div className="services-filter">
        {windowWidth >= heroContainerMediaQueries.xl && (
          <div
            style={{
              marginLeft: `${calc(
                (windowWidth - heroContainerMediaQueries.xl) / 2 + 138
              )}px`,
            }}
          />
        )}

        {windowWidth < heroContainerMediaQueries.xl &&
          windowWidth >= heroContainerMediaQueries.lg && (
            <div
              style={{
                marginLeft: `${calc(
                  (windowWidth - heroContainerMediaQueries.lg) / 2 + 50
                )}px`,
              }}
            />
          )}

        {windowWidth < heroContainerMediaQueries.lg &&
          windowWidth >= heroContainerMediaQueries.md && (
            <div
              style={{
                marginLeft: `${calc(
                  (windowWidth - heroContainerMediaQueries.md) / 2 + 50
                )}px`,
              }}
            />
          )}

        {windowWidth < heroContainerMediaQueries.md && (
          <div
            style={{
              marginLeft: `${calc(
                (windowWidth - heroContainerMediaQueries.sm) / 2 - 8
              )}px`,
            }}
          />
        )}

        {filters.map((filter) => {
          return (
            <Tag
              tagname={filter}
              key={generateString(30)}
              onClick={() => handleCategoryClick(filter)}
              active={active === filter}
            />
          )
        })}
      </div>
    </ScrollContainer>
  )
}
